var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "headerPanelMobileMenu row" }, [
    _c("div", { staticClass: "profileContainerMobileMenu" }, [
      _c("div", { staticClass: "profileImgMobileMenu" }),
      _vm._v(" "),
      _c("span", { staticClass: "profileNameMobileMenu" }, [
        _vm._v("\n      " + _vm._s(_vm.username)),
        _c("br"),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "closePanelMobileMenu close-panel" },
      [
        _c("f7-icon", {
          staticClass: "imgClosePanelMobileMenu close-panel",
          attrs: { icon: _vm.isWhite() },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }